import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-rewardsref',
  templateUrl: './rewardsref.component.html',
  styleUrls: ['./rewardsref.component.scss'],
})
export class RewardsrefComponent implements OnInit {

  constructor(public router: Router,public auth: AuthService) { }

  ngOnInit() {}
  rewards(){
    this.router.navigate(['/rewards']);
  }
  refer(){
    this.router.navigate(['/refer-dash']);
  }
  referList(){
    this.router.navigate(['/referal-list']);
  }

}

